<template>
  <div>
    <a-form-model
      ref="ruleForm"
      layout="inline"
      :model="formInline"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="6">
          <a-form-model-item label="财务单号" prop="user">
            <a-input v-model="formInline.financeNo" placeholder="请输入">
            </a-input>
          </a-form-model-item>
        </a-col>
        <!-- <a-col :span="7">
          <a-form-model-item label="用户uid" prop="password">
            <a-input v-model="formInline.password" placeholder="请输入">
            </a-input>
          </a-form-model-item>
        </a-col> -->
        <a-col :span="7">
          <a-form-model-item label="收支类型" prop="moneyAdd">
            <a-select
              default-value="lucy"
              style="width: 120px"
              @change="handleChange"
              v-model="formInline.moneyAdd"
            >
              <a-select-option :value="true">收入</a-select-option>
              <a-select-option :value="false">支出</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="4">
          <a-form-model-item>
            <a-button type="primary" @click="seach"> 查询 </a-button>
            <a-button style="margin-left: 10px" @click="reset"> 重置 </a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-table
      class="tables"
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <!-- 收支类型 -->
      <!-- <template slot="moneyAdd" slot-scope="text, record">
        <span>{{ record.moneyAdd === true ? "收入" : "开支" }}</span>
      </template> -->

      <a-avatar slot="avatar" icon="user" />
    </a-table>
  </div>
</template>
<script>
import { storeWalletList, storeWalletListSeach } from "@/api/storeApi.js";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
  },
  {
    title: "财务单号",
    align: "center",
    dataIndex: "financeNoStr",
  },
  {
    title: "收支类型",
    dataIndex: "moneyAddStr",
    align: "center",
    slots: { customRender: "moneyAddStr" },
  },
  {
    title: "提交金额",
    dataIndex: "moneySubmit",
    align: "center",
  },
  {
    title: "落地金额",
    dataIndex: "moneyClean",
    align: "center",
  },
  {
    title: "佣金金额",
    dataIndex: "moneyRate",
    align: "center",
  },
  {
    title: "交易方式",
    dataIndex: "financeTypeStr",
    align: "center",
  },
  {
    title: "交易状态",
    dataIndex: "financeStatusStr",
    align: "center",
  },
  {
    title: "交易时间",
    dataIndex: "createTime",
    align: "center",
  },
];

export default {
  data() {
    return {
      formInline: {
        moneyAdd: "",
        financeNo: "",
        limit: 10,
        page: 1,
      },
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getStoreWalletList();
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      storeWalletList(10, this.pagination.current).then((res) => {
        this.data = res.data;
        console.log(res);
      });
      this.loading = false;
    },
    getStoreWalletList() {
      storeWalletList(10, 1).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    seach() {
      this.loading = true;
      storeWalletListSeach(
        this.formInline.limit,
        this.formInline.page,
        this.formInline.financeNo,
        this.formInline.moneyAdd
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
      });
    },
    reset() {
      this.getStoreWalletList();
      this.formInline = {};
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
  },
};
</script>
<style scoped>
.tables {
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/financialManagement/storeWallet/storeWalletContent.vue